import { render, staticRenderFns } from "./AddHeader.vue?vue&type=template&id=2ee547fa&scoped=true&"
import script from "./AddHeader.vue?vue&type=script&lang=ts&"
export * from "./AddHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AddHeader.vue?vue&type=style&index=0&id=2ee547fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee547fa",
  null
  
)

export default component.exports